import { useState } from 'react';
import { sortAscending, sortDescending } from './helpers';

const DEFAULT_SORT_ORDER = 'asc';

export default () => {
  const [sortBy, setSortBy] = useState('');
  const [sortOrder, setSortOrder] = useState(DEFAULT_SORT_ORDER);

  const getColumnSorting = (columnKey, order) => {
    return order === 'desc'
      ? (a, b) => sortDescending(a[columnKey], b[columnKey])
      : (a, b) => sortAscending(a[columnKey], b[columnKey]);
  };

  const onColumnSort = (column, order) => {
    if (!column.isSortable) return;
    if (sortBy !== column.key) {
      setSortBy(column.key);
    }
    if (sortOrder !== order) {
      setSortOrder(order);
    }
  };

  const resetSorting = () => {
    setSortBy('');
    if (sortOrder !== DEFAULT_SORT_ORDER) {
      setSortOrder(DEFAULT_SORT_ORDER);
    }
  };

  return { sortBy, sortOrder, getColumnSorting, onColumnSort, resetSorting };
};
